export default {
  title: {
    id: 'asp_action_bar_declare_problem_list_step_title',
    defaultMessage: 'Choose the issue that’s holding up the return',
  },
  sendMessageTitle: {
    id: 'asp_action_bar_problem_declaration_list_step_title',
    defaultMessage: 'Send a message',
  },
  sendMessageProblemListInstruction: {
    id: 'asp_action_bar_send_message_problem_list_step_subtitle',
    defaultMessage: 'Select the issue that best describes your situation.',
  },
  outOfWarranty: {
    id: 'asp_action_bar_declare_problem_list_step_out_of_warranty',
    defaultMessage: 'Item is out of warranty',
  },
  damagedPackage: {
    id: 'asp_action_bar_declare_problem_list_step_damaged_package',
    defaultMessage: 'Damaged package and item in transit',
  },
  accountLocked: {
    id: 'asp_action_bar_declare_problem_list_step_account_locked',
    defaultMessage: 'Item locked to iCloud / Google',
  },
  codeLocked: {
    id: 'asp_action_bar_declare_problem_list_step_code_locked',
    defaultMessage: 'Item is code / pattern locked',
  },
  itemNotReceived: {
    id: 'asp_action_bar_declare_problem_list_step_item_not_received',
    defaultMessage: 'Item not received',
  },
  missingPart: {
    id: 'asp_action_bar_declare_problem_list_step_missing_part',
    defaultMessage: 'Missing part / accessories',
  },
  wrongItem: {
    id: 'asp_action_bar_declare_problem_list_step_wrong_item',
    defaultMessage: 'Wrong item received',
  },
  problemNotIdentified: {
    id: 'asp_action_bar_declare_problem_list_step_problem_not_identified',
    defaultMessage: 'Problem reported couldn’t be identified',
  },
  info: {
    id: 'asp_action_bar_declare_problem_list_step_info',
    defaultMessage: 'Why it’s important to take the right action',
  },
  infoTooltip: {
    id: 'asp_action_bar_declare_problem_list_step_info_tooltip',
    defaultMessage:
      'It’s important to take the right action now so the customer has clear next steps. Otherwise, we’ll consider this return unhandled and in violation of the Quality Charter.',
  },
  other: {
    id: 'asp_action_bar_declare_problem_list_step_other',
    defaultMessage: 'Other',
  },
}
